var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_10455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7633 9.84501L18.5166 8.39668C18.2783 8.12168 18.0858 7.60835 18.0858 7.24168V5.68335C18.0858 4.71168 17.2883 3.91418 16.3166 3.91418H14.7583C14.4008 3.91418 13.8783 3.72168 13.6033 3.48335L12.155 2.23668C11.5225 1.69585 10.4866 1.69585 9.84497 2.23668L8.40581 3.49251C8.13081 3.72168 7.60831 3.91418 7.25081 3.91418H5.66497C4.69331 3.91418 3.89581 4.71168 3.89581 5.68335V7.25085C3.89581 7.60835 3.70331 8.12168 3.47414 8.39668L2.23664 9.85418C1.70497 10.4867 1.70497 11.5133 2.23664 12.1458L3.47414 13.6033C3.70331 13.8783 3.89581 14.3917 3.89581 14.7492V16.3167C3.89581 17.2883 4.69331 18.0858 5.66497 18.0858H7.25081C7.60831 18.0858 8.13081 18.2783 8.40581 18.5167L9.85414 19.7633C10.4866 20.3042 11.5225 20.3042 12.1641 19.7633L13.6125 18.5167C13.8875 18.2783 14.4008 18.0858 14.7675 18.0858H16.3258C17.2975 18.0858 18.095 17.2883 18.095 16.3167V14.7583C18.095 14.4008 18.2875 13.8783 18.5258 13.6033L19.7725 12.155C20.3041 11.5225 20.3041 10.4775 19.7633 9.84501ZM14.8133 9.26751L10.3858 13.695C10.2575 13.8233 10.0833 13.8967 9.89997 13.8967C9.71664 13.8967 9.54247 13.8233 9.41414 13.695L7.19581 11.4767C6.92997 11.2108 6.92997 10.7708 7.19581 10.505C7.46164 10.2392 7.90164 10.2392 8.16747 10.505L9.89997 12.2375L13.8416 8.29585C14.1075 8.03001 14.5475 8.03001 14.8133 8.29585C15.0791 8.56168 15.0791 9.00168 14.8133 9.26751Z",
    fill: "#46C65A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_10455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.5c7953d44303bcf505daad321b8f2812.svg";
export { ForwardRef as ReactComponent };